export const ERROR_CODES = {
    AUTH_NOT_AUTHENTICATED: 'errors.auth.not_authenticated',
    AUTH_INVALID_CREDENTIALS: 'errors.auth.invalid_credentials',
    AUTH_EMAIL_EXISTS: 'errors.auth.email_exists',
    AUTH_EMAIL_IN_USE: 'errors.auth.email_in_use',
    AUTH_EMAIL_NOT_CHANGEABLE: 'errors.auth.email_not_changeable',
    CONNECTION_NOT_FOUND: 'errors.connection.not_found',
    FB_NO_TOKEN: 'errors.facebook.no_token',
    FB_NO_PAGE_TOKEN: 'errors.facebook.no_page_token',
    VALIDATION_REQUIRED: 'errors.validation.required',
    VALIDATION_TOO_SHORT: 'errors.validation.too_short',
    VALIDATION_TOO_LONG: 'errors.validation.too_long',
    VALIDATION_INVALID_EMAIL: 'errors.validation.invalid_email',
    VALIDATION_INVALID_TYPE: 'errors.validation.invalid_type',
    VALIDATION_INVALID: 'errors.validation.invalid',
    UNKNOWN: 'errors.unknown',
};
export function isErrorCode(s) {
    return typeof s === 'string' && s.startsWith('errors.');
}
//# sourceMappingURL=errors.js.map